import { fbDB } from "../config/firebase";
import { FEEDBACK_WATCH_ON, FEEDBACK_WATCH_OFF } from "./types";

export const feedbackWatchOn = () => async dispatch => {
  fbDB.ref("/feedback").on("value", snapshot =>
    dispatch({
      type: FEEDBACK_WATCH_ON,
      payload: snapshot.val()
    })
  );
};

export const feedbackWatchOff = () => async dispatch => {
  fbDB.ref("/feedback").off();
  return dispatch({
    type: FEEDBACK_WATCH_OFF,
    payload: null
  });
};

export const feedbackTargetToggle = (cCode, uid) => async dispatch => {
  fbDB.ref(`/feedback/${cCode}/absent`).transaction(data => {
    if (data === null) {
      return [uid];
    } else if (data.filter(v => v === uid).length) {
      return data.filter(v => v !== uid);
    } else if (!data.filter(v => v === uid).length) {
      return [...data, uid];
    }
  });
};
